export default {
  app: {
    notFound: {
      title: '페이지를 찾을 수 없습니다.',
      subtitle: '잘못된 경로로 접근한 것 같습니다.',
      text: '걱정 마세요, 다시 페이지를 찾을 수 있도록 도와드리겠습니다.',
    },
  },
};
